import { Injectable } from '@angular/core';
import { ApiService, IGiftCardIntegrationState, IGiftCard } from '@cakeiteasy/web-utils';
import { Observable } from 'rxjs';

@Injectable()
export class GiftCardsApiService {
  constructor(private _api: ApiService) {
  }

  public getIntegrationState(countryCode: string): Observable<IGiftCardIntegrationState> {
    return this._api.get('gift_cards', 'integration_state', null, {
      params: { countryCode }
    });
  }

  public getGiftCardByCode(code: string): Observable<IGiftCard> {
    return this._api.get('gift_cards', 'gift_card_by_code', { code });
  }
}
